import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { getExternalHref } from 'src/utils/getExternalHref';
import { tryGetTargetMessages, getTargetMessages } from 'src/utils/getTargetMessages';
import { LanguagePairLink } from 'src/types/link';
import { useMultiTargetLanguagePairs } from '../useMultiTargetLanguagePairs';
import * as localesWithMessages from './messages';

export const useLanguagesLinks = (): LanguagePairLink[] => {
  const intl = useIntl();
  const baseLanguages = useMultiTargetLanguagePairs();

  return useMemo(
    () =>
      baseLanguages
        .filter(
          ({ targetLanguageBaseLocale }) =>
            !!tryGetTargetMessages(localesWithMessages, targetLanguageBaseLocale),
        )
        .map(({ sourceLanguageLocale, targetLanguageBaseLocale, targetLanguageLocales }) => {
          const msgs = getTargetMessages(localesWithMessages, targetLanguageBaseLocale);

          return {
            image: {
              externalSrc: targetLanguageLocales[0].targetLanguageImage,
              name:
                targetLanguageLocales.length > 1
                  ? `multi-country-flag-${targetLanguageBaseLocale}`
                  : null,
            },
            text: intl.formatMessage(msgs.learnLanguage),
            href: getExternalHref({
              linkType: 'memrise-learn-language',
              query: {
                sourceLanguageLocale,
                // take the first target language as learn links are the same
                targetLanguageLocale: targetLanguageLocales[0].targetLanguageLocale,
              },
            }),
          };
        })
        .sort((a, b) => a.href.localeCompare(b.href)),
    [baseLanguages, intl],
  );
};
